import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { ModalEl, VerticalAlignment } from 'common/components/modal';
import { SelectEl } from 'common/components/select';
import { FileUploaderEl } from 'common/components/file-uploader';
import { ButtonTheme } from 'common/components/button/constants';
import { SvgIconEl } from 'common/components/svg-icon';
import { QueryBlockEl } from '../query-block';
export function template() {
  const {
    state,
    helpers
  } = this;
  return jsx("div", {
    sel: '.map-lookup-table-modal'
  }, jsx(ModalEl, {
    attrs: {
      open: this.attr("open"),
      closeable: true,
      'grow-to-content': true,
      'vertical-alignment': this.attr("type") === "import" ? VerticalAlignment.Top : VerticalAlignment.Center
    },
    on: {
      change: ev => helpers.handleModalClose(ev)
    }
  }, jsx("div", {
    sel: '.mp-modal-content'
  }, jsx("div", {
    sel: '.mp-confirm-title'
  }, helpers.getModalTitle()), jsx("div", {
    sel: '.section-title'
  }, "Lookup Table"), state.selectTableErrorMessage ? jsx("div", {
    sel: '.input-row-error'
  }, state.selectTableErrorMessage) : null, jsx("div", {
    sel: '.input-row'
  }, jsx("div", {
    sel: '.select-group',
    class: {
      hidden: state.hideSelect || this.attr("type") === "import"
    }
  }, jsx(SelectEl, {
    attrs: {
      sections: helpers.getLookupTableSections(),
      'selected-option': helpers.getSelectedLabel(),
      'search-placeholder': "Search",
      disabled: Boolean(state.fileProcessingDescription),
      elref: "lookupTableSelect"
    },
    on: {
      change: helpers.selectLookupTable
    }
  }), jsx("div", {
    sel: '.or'
  }, "or")), jsx(FileUploaderEl, {
    attrs: helpers.getFileUploadBlockAttrs(),
    on: {
      change: helpers.uploadLookupTableCSV,
      delete: helpers.handleDeleteUpload
    }
  })), jsx("div", {
    sel: '.section-title'
  }, "Map to Property"), state.invalidPropertyErrorMessage ? jsx("div", {
    sel: '.input-row-error'
  }, state.invalidPropertyErrorMessage) : null, jsx(QueryBlockEl, {
    attrs: helpers.getQueryBlockAttrs(),
    on: {
      select: helpers.handleSelectProperty,
      remove: helpers.handleRemoveProperty
    }
  }), jsx("div", {
    sel: '.button-row'
  }, jsx("div", {
    sel: '.info-link'
  }, jsx("a", {
    attrs: {
      href: "https://help.mixpanel.com/hc/en-us/articles/360044139291-Lookup-tables",
      target: "_blank"
    },
    on: {
      click: helpers.trackInfoClick
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "info"
    }
  }), "Learn more about Lookup Tables")), jsx("div", {
    sel: '.right-buttons'
  }, jsx("div", {
    sel: '.cancel-button-wrapper'
  }, jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Tertiary,
      tabindex: 0
    },
    on: {
      click: helpers.close
    }
  }, "Cancel")), jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Primary,
      disabled: helpers.shouldDisableConfirm(),
      icon: state.savePending ? "spinner" : "",
      tabindex: 0,
      elref: "applyMappingButton"
    },
    on: {
      click: helpers.handleConfirmClick
    }
  }, helpers.getConfirmButtonLabel()))))));
}